"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Vue, Ref } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import QrcodeVue from "qrcode.vue";
let checkTotpQrCode = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.totp_code = null;
    this.totp_qrcode = null;
  }
  mounted() {
    return __async(this, null, function* () {
    });
  }
  open(data) {
    return __async(this, null, function* () {
      this.totp_code = data;
      let qrsecret = `otpauth://totp/Amazon:${data.account}?secret=${data.secret}`;
      this.totp_qrcode = qrsecret;
      this._check_totp_qr_code.show();
    });
  }
  close() {
  }
};
__decorateClass([
  Ref("checkTotpQrCode")
], checkTotpQrCode.prototype, "_check_totp_qr_code", 2);
checkTotpQrCode = __decorateClass([
  Component({
    components: {
      UiDialog,
      QrcodeVue
    }
  })
], checkTotpQrCode);
export {
  checkTotpQrCode as default
};
